import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit"; // Import the FullscreenExitIcon

const Header = ({ color, headerTitle }) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleFullscreenToggle = () => {
    if (!document.fullscreenElement && !isFullscreen) {
      // Request fullscreen on both desktop and mobile browsers
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        // Firefox
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        // Chrome/Safari
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        // IE
        document.documentElement.msRequestFullscreen();
      }
      setIsFullscreen(true);
    } else {
      // Exit fullscreen on both desktop and mobile browsers
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome/Safari
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE
        document.msExitFullscreen();
      }
      setIsFullscreen(false);
    }
  };

  const list = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={handleDrawerClose}
      onKeyDown={handleDrawerClose}
    >
      <List>
        {["Buy Now!", "Try Sports GPT", "Open 3D Viewer", "View in a Room"].map(
          (text) => (
            <React.Fragment key={text}>
              <ListItem button>
                <ListItemText primary={text} />
                <ListItemIcon>
                  <FullscreenIcon fontSize="large" />
                </ListItemIcon>
              </ListItem>
              <Divider
                sx={{
                  marginLeft: 2,
                  marginRight: 2,
                }}
              />
            </React.Fragment>
          )
        )}
      </List>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        sx={{
          position: "fixed",
          bgcolor: color ? color : "#275DAA",
          minHeight: isMobile ? 50 : 60,
        }}
        position="fixed"
      >
        <Toolbar
          variant="dense"
          sx={{
            minHeight: isMobile ? 50 : 60,
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Uncomment to add menu button */}
          {/* <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{
              position: "relative",
              animation: "highlight 3s 10",
              "@keyframes highlight": {
                "0%, 100%": {
                  color: "inherit",
                  zIndex: 1,
                },
                "50%": {
                  color: "black",
                  zIndex: 10,
                },
              },
            }}
            onClick={handleDrawerOpen}
          >
            <MenuIcon />
          </IconButton> */}
          <Box sx={{ flexGrow: 1, textAlign: "center" }}>
            <Typography variant="h5" color="inherit" component="div">
              {headerTitle ? headerTitle : "Fiducia AI"}
            </Typography>
          </Box>
          <IconButton
            color="inherit"
            onClick={handleFullscreenToggle}
            sx={{
              position: "absolute",
              right: 16,
              fontSize: isMobile ? 30 : 40, // Larger for mobile
            }}
          >
            {/* {isFullscreen ? (
              <FullscreenExitIcon fontSize="inherit" />
            ) : (
              <FullscreenIcon fontSize="inherit" />
            )} */}
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: {
            top: isMobile ? "50px" : "60px",
            height: `calc(100% - ${isMobile ? 50 : 60}px)`,
            backgroundColor: "#f2f2f2",
            opacity: 0.95,
          },
        }}
      >
        {list}
      </Drawer>
    </Box>
  );
};

export default Header;
